export default function SearchFactory($q) {
    var fn = this;

    /**
     * API V3
     */

    return fn;
}
